export const poiCategories = [
  { value: 'restaurant', label: 'restaurant' },
  { value: 'office', label: 'office' },
  {
    value: 'gas_station',
    label: 'gas station, petrol station, fuel, gasoline, petrol',
  },
  { value: 'fast_food', label: 'fast food' },
  { value: 'place_of_worship', label: 'place of worship' },
  { value: 'cafe', label: 'cafe' },
  { value: 'bar', label: 'bar' },
  { value: 'school', label: 'school' },
  {
    value: 'car_dealership',
    label: 'car dealership, car dealer, auto dealer',
  },
  { value: 'airport', label: 'airport' },
  {
    value: 'car_dealership',
    label: 'car dealership, car dealer, auto dealer',
  },
  { value: 'parking_lot', label: 'parking, parking lot, parking garage' },
  { value: 'auto_repair', label: 'mechanic, auto repair, car repair' },
  { value: 'university', label: 'university' },
  { value: 'clothing_store', label: 'clothes store, clothing' },
  { value: 'park', label: 'park' },
  { value: 'hairdresser', label: 'barber, hairdresser, hair salon' },
  { value: 'medical_clinic', label: 'medical clinic, medical center' },
  { value: 'church', label: 'church' },
  { value: 'office', label: 'office' },
  { value: 'pharmacy', label: 'pharmacy, drug store' },
  { value: 'coffee_shop', label: 'coffee shop' },
  { value: 'grocery', label: 'grocery store' },
  { value: 'supermarket', label: 'supermarket' },
  { value: 'factory', label: 'factory' },
  { value: 'salon', label: 'salon' },
  { value: 'real_estate_agent', label: 'real estate agent' },
  { value: 'convenience_store', label: 'convenience store, minimart' },
  { value: 'fitness_center', label: 'gym, fitness center' },
  { value: 'hospital', label: 'hospital' },
  {
    value: 'rest_area',
    label:
      'rest area, rest stop, motorway service area, lay-by, service centre, oasis',
  },
  { value: 'care_services', label: 'care services' },
  {
    value: 'charging_station',
    label:
      'charging station, electric vehicle charging station, EV charging station, EV charger, EV connect charging station',
  },
  { value: 'wholesale_store', label: 'wholesale' },
  { value: 'doctors_office', label: 'doctors office' },
  { value: 'pizza_restaurant', label: 'pizza, pizza restaurant, pizzeria' },
  { value: 'american_restaurant', label: 'american restaurant' },
  { value: 'dentist', label: 'dentist' },
  { value: 'furniture_store', label: 'furniture store' },
  { value: 'electronics_shop', label: 'electronics, electronics store' },
  { value: 'landscaping', label: 'landscaping, yardwork' },
  { value: 'shopping_mall', label: 'mall' },
  { value: 'bakery', label: 'bakery, bake shop, pastry shop, bakehouse' },
  { value: 'farm', label: 'farm' },
  { value: 'monument', label: 'monument' },
  { value: 'fire_station', label: 'fire station' },
  { value: 'bike_rental', label: 'bike rental' },
  { value: 'car_wash', label: 'car wash' },
  { value: 'bank', label: 'bank' },
  { value: 'mexican_restaurant', label: 'mexican restaurant' },
  { value: 'library', label: 'library' },
  { value: 'railway_station', label: 'railway station, train station' },
  { value: 'government_offices', label: 'government buildings' },
  { value: 'sports_club', label: 'sports club' },
  { value: 'cemetery', label: 'cemetery' },
  { value: 'italian_restaurant', label: 'italian food, italian restaurant' },
  { value: 'medical_practice', label: 'medical practice' },
  { value: 'health_services', label: 'health services' },
  { value: 'jewelry_store', label: 'jewelry store' },
  { value: 'liquor_store', label: 'liquor store' },
  { value: 'post_office', label: 'post office' },
  { value: 'warehouse', label: 'warehouse' },
  { value: 'market', label: 'market' },
  { value: 'lawyer', label: 'lawyer, legal services' },
  { value: 'field', label: 'Sports Fields' },
  { value: 'photographer', label: 'photographer, photo studio' },
  { value: 'event_space', label: 'event space, event venue' },
  { value: 'public_transportation_station', label: 'public transit station' },
  { value: 'golf_course', label: 'golf, golf course' },
  { value: 'sports_shop', label: 'sports store' },
  { value: 'pet_store', label: 'pet store' },
  { value: 'atm', label: 'ATM' },
  { value: 'pub', label: 'pub' },
  { value: 'information_technology_company', label: 'information technology' },
  { value: 'breakfast_restaurant', label: 'breakfast restaurant' },
  { value: 'home_repair', label: 'home services store' },
  { value: 'hardware_store', label: 'hardware store' },
  { value: 'townhall', label: 'town hall, city hall, townhall' },
  { value: 'cannabis_dispensary', label: 'dispensary, cannabis shop' },
  { value: 'childcare', label: 'childcare, preschool' },
  { value: 'police_station', label: 'police station' },
  { value: 'pet_store', label: 'pet store' },
  { value: 'studio', label: 'studio' },
  { value: 'winery', label: 'winery' },
  { value: 'kindergarten', label: 'kindergarten' },
  { value: 'beauty_store', label: 'cosmetics shop, beauty supply store' },
  { value: 'veterinarian', label: 'veterinarian, vet, animal hospital' },
  { value: 'government_offices', label: 'government buildings' },
  { value: 'phone_store', label: 'mobile phone store' },
  { value: 'advertising_agency', label: 'ad agency, advertising agency' },
  { value: 'department_store', label: 'department store' },
  { value: 'ice_cream', label: 'ice cream shop' },
  { value: 'monument', label: 'monument' },
  {
    value: 'nongovernmental_organization',
    label: 'NGO, nongovernmental organization',
  },
  { value: 'funeral_home', label: 'funeral home, funeral directors' },
  { value: 'brewery', label: 'brewery' },
  { value: 'dessert_shop', label: 'confectionary, dessert shop' },
  { value: 'car_rental', label: 'car rental, auto rental' },
  { value: 'florist', label: 'florist, flower shop' },
  { value: 'japanese_restaurant', label: 'japanese restaurant' },
  { value: 'indian_restaurant', label: 'indian restaurant' },
  { value: 'community_center', label: 'community center' },
  { value: 'sports_center', label: 'sports center' },
  { value: 'gift_shop', label: 'gift shop' },
  { value: 'stadium', label: 'stadium' },
  { value: 'optician', label: 'optical' },
  { value: 'cinema', label: 'movie theater, cinema' },
  { value: 'marina', label: 'marina' },
  {
    value: 'seafood_restaurant',
    label: 'seafood restaurant, fish restaurant',
  },
  { value: 'book_store', label: 'bookstore, book store' },
  { value: 'bicycle_shop', label: 'bike store, bicycles' },
  { value: 'garden_store', label: 'garden supply store' },
  { value: 'college', label: 'college' },
  {
    value: 'burger_restaurant',
    label: 'burger joint, burgers, hamburger restaurant, hamburgers',
  },
  { value: 'chinese_restaurant', label: 'chinese restaurant, chinese food' },
  { value: 'alternative_healthcare', label: 'alternative healthcare' },
  { value: 'laundry', label: 'laundry, laundromat' },
  { value: 'theatre', label: 'theater, theatre' },
  { value: 'thrift_shop', label: 'thrift shop, second hand store' },
  { value: 'tobacco_shop', label: 'tobacco shop, smoke shop' },
  { value: 'sushi_restaurant', label: 'sushi restaurant' },
  { value: 'nightclub', label: 'club, nightclub' },
  { value: 'arts_center', label: 'arts center' },
  { value: 'resort', label: 'resort' },
  { value: 'greek_restaurant', label: 'greek restaurant' },
  { value: 'playground', label: 'playground' },
  { value: 'butcher_shop', label: 'butcher' },
  { value: 'asian_restaurant', label: 'asian food, asian restaurant' },
  { value: 'arts_and_craft_store', label: 'arts and craft store' },
  { value: 'boutique', label: 'boutique shop' },
  { value: 'toy_store', label: 'toy store' },
  { value: 'french_restaurant', label: 'french restaurant' },
  { value: 'spanish_restaurant', label: 'spanish restaurant' },
  { value: 'thai_restaurant', label: 'thai restaurant' },
  { value: 'mediterranean_restaurant', label: 'mediterranean restaurant' },
  { value: 'brazilian_restaurant', label: 'brazilian restaurant' },
  { value: 'american_restaurant', label: 'american restaurant' },
  { value: 'german_restaurant', label: 'german restaurant' },
  {
    value: 'peruvian_restaurant',
    label: 'peruvian restaurant, andean restaurant',
  },
  { value: 'italian_restaurant', label: 'italian food, italian restaurant' },
  { value: 'chinese_restaurant', label: 'chinese restaurant, chinese food' },
  { value: 'chinese_restaurant', label: 'chinese restaurant, chinese food' },
  { value: 'asian_restaurant', label: 'asian food, asian restaurant' },
  { value: 'middle_eastern_restaurant', label: 'middle eastern restaurant' },
  { value: 'mediterranean_restaurant', label: 'mediterranean restaurant' },
  { value: 'carribean_restaurant', label: 'carribean restaurant' },
  { value: 'japanese_restaurant', label: 'japanese restaurant' },
  { value: 'african_restaurant', label: 'african restaurant' },
  { value: 'spanish_restaurant', label: 'spanish restaurant' },
  { value: 'turkish_restaurant', label: 'turkish restaurant' },
  { value: 'french_restaurant', label: 'french restaurant' },
  { value: 'creole_restaurant', label: 'creole restaurant' },
  { value: 'korean_restaurant', label: 'korean restaurant' },
  { value: 'cuban_restaurant', label: 'cuban restaurant' },
  { value: 'cuban_restaurant', label: 'cuban restaurant' },
];

export const otherPoiCategory = {
  value: 'other',
  label: 'Other',
};
